<template>
  <v-container class="justify-center" fill-height fluid ref="reportContainer">
    <v-overlay :value="loading">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
        <p class="mt-4">Please wait...</p>
      </div>
    </v-overlay>
    <v-card
      flat
      outlined
      class="my-8 pa-8"
      style="min-width: 1400px; border-style: none"
      v-if="response && response.projectTitle"
    >
      <v-layout row wrap>
        <v-flex name="mypan">
          <div height="72px" class="px-2 align-center white default-border">
            <v-row>
              <v-col cols="6">
                <div class="row pa-4 px-8 mt-2">
                  <div class="text-h4">
                    {{
                      response && response.projectTitle
                        ? `Project: ${response.projectTitle}`
                        : ""
                    }}

                    <div
                      class="text-h6 mt-8"
                      v-if="
                        response &&
                        response.analysisLevel &&
                        response.technologyType
                      "
                    >
                      <span class="grey--text"> Analysis Level: </span>
                      {{ toTitleCase(response.analysisLevel) }}
                      |
                      <span
                        class="grey--text"
                        v-if="
                          response &&
                          response.analysisLevel &&
                          response.technologyType
                        "
                      >
                        Technology :
                      </span>
                      {{ toTitleCase(response.technologyType) }}
                    </div>
                  </div>
                </div>
              </v-col>

              <v-col>
                <div class="row pa-4 px-8 mt-2 justify-end">
                  <v-btn
                    depressed
                    rounded
                    dark
                    color="#219fd4"
                    @click="downloadPdf"
                    :loading="downloadLoading"
                  >
                    Download PDF
                    <v-icon> mdi-download </v-icon>
                    <!-- <v-icon large color="red"> mdi-file-pdf-box </v-icon> -->
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <template v-if="iskeyfindingsDataLoaded" ref="KeyFindingsReport">
              <key-findings-report
                :keyfindingsdata="keyfindingsData"
                :reportImage="'give the image path that need to be updated in og tag'"
                :id="id"
                flat
              />
            </template>

            <template v-if="isSystemprofiledataLoaded">
              <div class="mt-10">
                <system-profile-report
                  :systemProfileReportData="systemprofiledata"
                  :analysisLevel="response.analysisLevel"
                />
              </div>
            </template>

            <template v-if="powerflowAnalysisData">
              <v-card flat outlined class="mx-auto mt-10">
                <v-card-title> Powerflow Analysis </v-card-title>
                <v-row class="mx-auto" style="text-align: center">
                  <v-col>Voltage Violation % of hours - Year 1 
                    <Tooltips :Tooltip="voltageviolationtooltip" />
                  </v-col>
                  <v-col>Average distribution loss % - Year 1
                    <Tooltips :Tooltip="avgdistributiontooltip" />
                  </v-col>
                  <v-col
                    >Peak as % of
                    <template
                      v-if="
                        response.analysisLevel === 'dt' ||
                        response.analysisLevel === 'feeder' ||
                        response.analysisLevel === 'substation'
                      "
                    >
                      {{ toTitleCase(response.analysisLevel) }}
                    </template>
                    <template
                      v-if="
                        response.analysisLevel !== 'dt' &&
                        response.analysisLevel !== 'feeder' &&
                        response.analysisLevel !== 'substation'
                      "
                    >
                      <!-- maximum power carrying - Year 1 -->
                    </template>
                    Capacity-Year1
                    <template v-if="response.analysisLevel === 'dt'">
                    <Tooltips :Tooltip="dtpeakcapacitytooltip" />
                  </template>
                  <template v-if="response.analysisLevel === 'feeder'">
                    <Tooltips :Tooltip="feederpeakcapacitytooltip" />
                  </template>
                  <template v-if="response.analysisLevel === 'substation'">
                    <Tooltips :Tooltip="substationpeakcapacitytooltip" />
                  </template>
                    </v-col>

                  <v-col>Capacity upgradation in years
                   <template v-if="response.analysisLevel === 'dt'">
                    <Tooltips :Tooltip="dtcapacityupgradationtooltip" />
                  </template>
                  <template v-if="response.analysisLevel === 'feeder'">
                    <Tooltips :Tooltip="feedercapacityupgradationtooltip" />
                  </template>
                  <template v-if="response.analysisLevel === 'substation'">
                    <Tooltips :Tooltip="substationcapacityupgradationtooltip" />
                  </template>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div
                      v-if="
                        powerflowAnalysisData.voltageViolationPercentOfHours
                      "
                      ref="VoltageViolation"
                    >
                      <bar-chart
                        :datasets="[
                          {
                            data: powerflowAnalysisData.voltageViolationPercentOfHours,
                            label: 'Voltage Violation % of hours',
                            backgroundColor: barChartColours,
                            barPercentage: 0.4,
                            datalabels: barChartDataLableProps,
                          },
                        ]"
                        :labels="['BAU', 'DER']"
                      />
                    </div>
                  </v-col>

                  <v-col>
                    <div
                      v-if="powerflowAnalysisData.avgDistributionLossesPercent"
                      ref="avgdistricutionlosses"
                    >
                      <bar-chart
                        :datasets="[
                          {
                            data: powerflowAnalysisData.avgDistributionLossesPercent,
                            label: 'AVG Distribution losses %',
                            backgroundColor: barChartColours,
                            barPercentage: 0.4,
                            datalabels: barChartDataLableProps,
                          },
                        ]"
                        :labels="['BAU', 'DER']"
                      />
                    </div>
                  </v-col>

                  <v-col>
                    <div
                      v-if="powerflowAnalysisData.peakFeederCapacityPercent"
                      ref="feedercapacity"
                    >
                      <bar-chart
                        :datasets="[
                          {
                            data: powerflowAnalysisData.peakFeederCapacityPercent,
                            label: `Peak as % of ${(response.analysisLevel)} capacity`,
                            backgroundColor: barChartColours,
                            barPercentage: 0.4,
                            datalabels: barChartDataLableProps,
                          },
                        ]"
                        :labels="['BAU', 'DER']"
                      />
                    </div>
                  </v-col>
                  <v-col>
                    <div
                      v-if="GroupedLoadProfileYearlyData.datasets"
                      ref="capacityupgradation"
                    >
                      <grouped-bar-chart
                        :datasets="GroupedLoadProfileYearlyData.datasets"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </template>
            <template v-if="loadProfileYearlyData.datasets">
              <v-card flat outlined class="mx-auto mt-10">
                <v-card-title>
                  <template>
                    <v-row>
                      <v-col cols="4">Load Profile and Grid Power
                        <Tooltips :Tooltip="loadprofiletooltip" />
                      </v-col>
                    </v-row>
                  </template>
                </v-card-title>
                <div ref="loadProfileYearlyData" style="width:1320px;height:420px">
                  <div class="row align-center justify-end">
                          <v-icon
                            @click="
                              downloadLoadandGridCsv(
                                'loadProfileYearlyData',
                                loadProfileYearlyData.datasets
                              )
                            "
                          >
                            mdi-download
                          </v-icon>
                          <template>
                            <v-icon> mdi-calendar-range </v-icon>
                            <DateRangePicker
                              v-model="loadProfileYearlyDataDateRange"
                              :type="date"
                              :auto-apply="true"
                              :autoApply="true"
                              :ranges="false"
                              :show-dropdowns="false"
                              class="form-control"
                              :format="dateFormat"
                              :minDate = "mindate"
                              :maxDate = "maxdate"
                            >
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot"
                              >
                                <h3>Date range</h3>
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                              </div>
                            </DateRangePicker>
                          </template>
                          <v-btn
                            :loading="loadingLoadProfile"
                            class="ml-4"
                            @click="resetDate(loadProfileYearlyDataDateRange)"
                            >Clear</v-btn
                          >
                          <v-btn
                            :loading="loadingLoadProfile"
                            class="ml-4"
                            @click="getLoadProfileYearlyData"
                            >Apply</v-btn
                          >
                        </div>
                  <line-chart-latest
                    chartId="loadProfileYearlyData"
                    :datasets="loadProfileYearlyData.datasets"
                    :labels="loadProfileYearlyData.labels"
                    yTitle="Power (MW)"
                    xTitle="Hours"
                    annotationId="loadProfileYearlyData"
                    :loading="loadingLoadProfile"
                  />
                </div>
              </v-card>
            </template>
            <template v-if="voltageProfileYearlyData.datasets">
              <v-card flat outlined class="mx-auto mt-10">
                <v-card-title>
                  <template>
                    <v-row>
                      <v-col cols="4">Voltage Profile 
                        <Tooltips :Tooltip="voltageprofiletooltip" />
                      </v-col>

                      <v-col cols="8">

                      </v-col>
                    </v-row>
                  </template>
                </v-card-title>
                <div ref="voltageProfileYearlyData" style="width:1320px;height:420px">
                  <div class="row align-center justify-end">
                          <v-icon
                            @click="
                              downloadVoltageCsv(
                                'voltageProfileYearlyData',
                                voltageProfileYearlyData.datasets
                              )
                            "
                          >
                            mdi-download
                          </v-icon>
                          <template>
                            <v-icon> mdi-calendar-range </v-icon>
                            <DateRangePicker
                              v-model="yearlyVoltageProfileDateRange"
                              :auto-apply="true"
                              :autoApply="true"
                              :ranges="false"
                              :show-dropdowns="false"
                              :minDate = "mindate"
                              :maxDate = "maxdate"
                              class="form-control"
                            >
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot"
                              >
                                <h3>Date range</h3>
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                              </div>
                            </DateRangePicker>
                          </template>
                          <v-btn
                            :loading="loadingLoadProfile"
                            class="ml-4"
                            @click="resetDate(yearlyVoltageProfileDateRange)"
                            >Clear</v-btn
                          >
                          <v-btn
                            :loading="loadingVoltageProfile"
                            class="ml-4"
                            @click="voltageProfileYearly"
                            >Apply</v-btn
                          >
                        </div>
                  <line-chart-latest
                    chartId="voltageProfileYearlyData"
                    :datasets="voltageProfileYearlyData.datasets"
                    :labels="voltageProfileYearlyData.labels"
                    yTitle="Voltage (p.u)"
                    xTitle="Hours"
                    annotationId="voltageProfileYearlyData"
                    :loading="loadingVoltageProfile"
                  />
                </div>
              </v-card>
            </template>

            <template v-if="distributionLossYearlyData.datasets">
              <v-card flat outlined class="mx-auto mt-10">
                <v-card-title>
                  <template>
                    <v-row>
                      <v-col cols="4">Distribution loss 
                        <Tooltips :Tooltip="distributionlosstooltip" />

                      </v-col>
                    </v-row>
                  </template>
                </v-card-title>
                <div ref="distributionLossYearlyData" style="width:1320px;height:420px">
                  <div class="row align-center justify-end">
                          <v-icon
                            @click="
                              downloadLargeCsv(
                                'distributionLossYearlyData',
                                distributionLossYearlyData.datasets,
                              )
                            "
                          >
                            mdi-download
                          </v-icon>
                          <template>
                            <v-icon> mdi-calendar-range </v-icon>
                            <DateRangePicker
                              v-model="distributionLossYearlyDataDateRange"
                              :auto-apply="true"
                              :autoApply="true"
                              :ranges="false"
                              :show-dropdowns="false"
                              :minDate = "mindate"
                              :maxDate = "maxdate"
                              class="form-control"
                            >
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot"
                              >
                                <h3>Date range</h3>
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                              </div>
                            </DateRangePicker>
                          </template>
                          <v-btn
                            :loading="loadingLoadProfile"
                            class="ml-4"
                            @click="
                              resetDate(distributionLossYearlyDataDateRange)
                            "
                            >Clear</v-btn
                          >
                          <v-btn
                            :loading="loadingDistributionLoss"
                            class="ml-4"
                            @click="getDistributionLossYearlyData"
                            >Apply</v-btn
                          >
                        </div>
                  <line-chart-latest
                    :datasets="distributionLossYearlyData.datasets"
                    :labels="distributionLossYearlyData.labels"
                    yTitle="Loss (%)"
                    xTitle="Hours"
                    :peak="distributionLossYearlyDataMax"
                    :turf="distributionLossYearlyDataMin"
                    :loading="loadingDistributionLoss"
                  />
                </div>
              </v-card>
            </template>

            <template v-if="energyBalanceDerData.datasets">
              <v-card flat outlined class="mx-auto mt-10">
                <v-card-title>
                  <template>
                    <v-row>
                      <v-col cols="4"> DER Power Balance 
                        <Tooltips :Tooltip="derpowertooltip" />
                      </v-col>

                    </v-row>
                  </template>
                </v-card-title>
                <div ref="energyBalanceDerData" style="width:1320px;height:420px">
                  <div class="row align-center justify-end">
                          <v-icon
                            @click="
                              downloadDERPowerBalanceCsv(
                                'energyBalanceDerData',
                                energyBalanceDerData.datasets,
                                energyBalanceDerData.labels
                              )
                            "
                          >
                            mdi-download
                          </v-icon>
                          <template>
                            <v-icon> mdi-calendar-range </v-icon>
                            <DateRangePicker
                              v-model="energyBalanceDerDataRange"
                              :auto-apply="true"
                              :autoApply="true"
                              :ranges="false"
                              :show-dropdowns="false"
                              :minDate = "mindate"
                              :maxDate = "maxdate"
                              class="form-control"
                            >
                              <div ref="date"
                                slot="header"
                                slot-scope="header"
                                class="slot"
                              >
                                <h3>Date range</h3>
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                              </div>
                            </DateRangePicker>
                          </template>
                          <v-btn
                            :loading="loadingLoadProfile"
                            class="ml-4"
                            @click="resetDate(energyBalanceDerDataRange)"
                            >Clear</v-btn
                          >

                          <v-btn
                            class="ml-4"
                            @click="getEnergyBalanceDer"
                            :loading="loadingEnergyBalanceDer"
                            >Apply</v-btn
                          >
                        </div>
                  <line-chart-latest
                    :datasets="energyBalanceDerData.datasets"
                    :labels="energyBalanceDerData.labels"
                    yTitle="Power (MW)"
                    xTitle="Hours"
                    :peak="energyBalanceDerDataMax"
                    :turf="energyBalanceDerDataMin"
                    :loading="loadingEnergyBalanceDer"
                  />
                </div>
              </v-card>
            </template>

            <template v-if="energyBalanceTotal.datasets">
              <v-card flat outlined class="mx-auto mt-10">
                <v-card-title>
                  Energy Balance (%)
                  <div style="padding-left: 5px">
                    <v-icon
                      small
                      class="mr-2"
                      @click="
                        downloadcsv(
                          'energyBalanceTotal',
                          csv_distributedEnergyTotal
                        )
                      "
                    >
                      mdi-arrow-collapse-down
                    </v-icon>
                  </div>
                </v-card-title>

                <div
                  style="width: 380px; height: 400px; margin-left: auto; margin-right: auto; padding-bottom: 2rem;"
                  ref="energyBalanceTotal">
                  <pie-chart-new
                    :datasets="energyBalanceTotal.datasets"
                    :labels="energyBalanceTotal.labels"
                    :options="chartOptions"
                  />
                </div>
              </v-card>
            </template>

            <template v-if="isNetworkBenifitLoad">
              <v-card flat class="mx-auto mt-10">
                <v-card-title class="px-0 mb-4"
                  >Value of distributed energy resources analysis</v-card-title
                >
                <v-row no-gutters>
                  <v-col cols="4">
                    <v-card class="pa-2" flat>
                      <h3 style="font-size: 20px;">Network benefits
                      <v-icon
                        small
                        class="mr-2"
                        @click="
                          downloadcsv(
                            'networkbenefits',
                            csv_distributedenergyresource
                          )
                        "
                      >
                        mdi-arrow-collapse-down
                      </v-icon></h3>
                    </v-card>
                    <v-card class="pa-2" flat>
                      <div class="d-flex justify-space-between align-center">
                        <div>Avoided cost of energy (ACE)</div>
                        <div>{{ ACE }} INR/kWh</div>
                      </div>
                    </v-card>
                    <v-card class="pa-2" flat>
                      <div class="d-flex justify-space-between align-center">
                        <div>Avoided distribution capacity cost (ADCC)</div>
                        <div>{{ ADCC }} INR/kWh</div>
                      </div>
                    </v-card>
                    <v-card class="pa-2" flat>
                      <div class="d-flex justify-space-between align-center">
                        <div>Avoided transmission capacity cost (ATCC)</div>
                        <div>{{ ATCC }} INR/kWh</div>
                      </div>
                    </v-card>
                    <v-card class="pa-2" flat>
                      <div class="d-flex justify-space-between align-center">
                        <div>Avoided generation capacity cost (AGCC)</div>
                        <div>{{ AGCC }} INR/kWh</div>
                      </div>
                    </v-card>
                    <v-card class="pa-2" flat>
                      <div class="d-flex justify-space-between align-center">
                        <div>
                          <b>Total network benefits </b>
                        </div>
                        <div>
                          <b
                            >{{ Totalnetworkbenefit }}
                            INR/kWh
                          </b>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="8">
                    <v-card class="pa-2" flat>
                      <div v-if="true" ref="chartnetworkbenifit">
                        <!-- <horizontal-bar-chart
                          :data="NetworkBenifit_Y"
                          :labels="NetworkBenifit_X"
                          :label="'Network benefit'"
                          :backgroundColor="horizBarChartBackgroudColor"
                        /> -->
                        <StackedChart
                          :backgroundColor="this.backgroundColors"
                          :data="NetworkBenifitDataset"
                          :labels="NetworkBenifit_X"
                          :label="'Network benefit'"
                          yTitle="INR/kWh"
                        />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </template>
            <template v-if="isSocietalBenefitsLoad">
              <v-row no-gutters>
                <v-col cols="4">
                  <v-card class="pa-2" flat>
                    <h3 style="font-size: 20px;">Societal benefits
                    <v-icon
                      small
                      class="mr-2"
                      @click="
                        downloadcsv('Societalbenefits', csv_SocietalBenefts)
                      "
                    >
                      mdi-arrow-collapse-down
                    </v-icon></h3>
                  </v-card>
                  <v-card class="pa-2" flat>
                    <div class="d-flex justify-space-between align-center">
                      <div>Avoided CO2 Emissions costs</div>
                      <div>{{ ACEC }} INR/kWh</div>
                    </div>
                  </v-card>
                  <v-card class="pa-2" flat>
                    <div class="d-flex justify-space-between align-center">
                      <div>Avoided SO2 Emissions costs</div>
                      <div>{{ ASEC }} INR/kWh</div>
                    </div>
                  </v-card>
                  <v-card class="pa-2" flat>
                    <div class="d-flex justify-space-between align-center">
                      <div>Avoided NO2 Emissions costs</div>
                      <div>{{ ANE }} INR/kWh</div>
                    </div>
                  </v-card>
                  <v-card class="pa-2" flat>
                    <div class="d-flex justify-space-between align-center">
                      <div>Avoided PM2.5 Emissions</div>
                      <div>{{ APE }} INR/kWh</div>
                    </div>
                  </v-card>
                  <v-card class="pa-2" flat>
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <b>Total societal benefits</b>
                      </div>
                      <div>
                        <b>{{ Totalsocietalbenifit }} INR/kWh</b>
                      </div>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="8">
                  <v-card class="pa-2" flat>
                    <div
                      v-if="SocietalBenefts_X.length > 0"
                      ref="SocietalBenefts"
                    >
                      <!-- <horizontal-bar-chart
                        :data="SocietalBenefts_Y"
                        :labels="SocietalBenefts_X"
                        :label="'Societal benefit'"
                        :backgroundColor="horizBarChartBackgroudColor"
                      /> -->

                      <StackedChart
                        :backgroundColor="this.backgroundColors"
                        :data="SocietalBenefitsDataset"
                        :labels="SocietalBenefts_X"
                        :label="'Societal benefit'"
                        yTitle="INR/kWh"
                      />
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </template>

            <template v-if="isDistributedenergyresourcesLoad">
              <v-row no-gutters>
                <v-col cols="4">
                  <v-card class="pa-2" flat>
                    <h3 style="font-size: 20px;">Value of distributed energy resources
                    <v-icon
                      small
                      class="mr-2"
                      @click="
                        downloadcsv(
                          'Distributedenergyresources',
                          csv_distributedenergyresources
                        )
                      "
                    >
                      mdi-arrow-collapse-down
                    </v-icon></h3>
                  </v-card>
                  <v-card class="pa-2" flat>
                    <div class="d-flex justify-space-between align-center">
                      <div>Network benefits</div>
                      <div>
                        {{ Totalnetworkbenefit }}
                        INR/kWh
                      </div>
                    </div>
                  </v-card>
                  <v-card class="pa-2" flat>
                    <div class="d-flex justify-space-between align-center">
                      <div>Societal benefits</div>
                      <div>
                        {{ Totalsocietalbenifit }}
                        INR/kWh
                      </div>
                    </div>
                  </v-card>
                  <v-card class="pa-2" flat>
                    <div class="d-flex justify-space-between align-center">
                      <div><b>Total VODER benefits</b></div>
                      <div>
                        <b>{{ totalVoderBenefits }} INR/kWh</b>
                      </div>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="8">
                  <v-card class="pa-2" flat>
                    <div
                      v-if="Distributedenergyresources_X.length > 0"
                      ref="distributedEnergyResources"
                    >
                      <StackedChart
                        :backgroundColor="this.backgroundColors"
                        :data="TotalVoderBenefitsDataset"
                        :labels="Distributedenergyresources_X"
                        :label="'Value of distributed energy resources'"
                        yTitle="INR/kWh"
                      />
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
// import HorizontalBarChart from "@/components/HorizontalBarChart.vue";
import BarChart from "@/components/BarChartNew.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { toTitleCase } from "@/utility/stringFormat.js";
import * as _html2canvas from "html2canvas";
import {
  formatDate,
  formatChartDate,
  formatFilterDate,
  displayDateTime,
} from "@/utility/dateTime.js";
import { roundUp } from "@/utility/roundUp.js";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import PieChartNew from "@/components/PieChartNew.vue";
import KeyFindingsReport from "@/components/keyfindingsreport.vue";
import SystemProfileReport from "@/components/systemprofilereport.vue";
import LineChartLatest from "../components/LineChartLatest.vue";

import dataService from "@/libs/dataService.js";
import GroupedBarChart from "../components/GroupedBarChartNew.vue";
import StackedChart from "../components/StackedChart.vue";
import Tooltips from "@/components/tooltips.vue";
export default {
  name: "report",
  components: {
    KeyFindingsReport,
    SystemProfileReport,
    PieChartNew,
    LineChartLatest,

    BarChart,
    // HorizontalBarChart,
    GroupedBarChart,
    StackedChart,
    DateRangePicker,
    Tooltips,
  },
  metaInfo() {
    return {
      title: "Solva - Evaluate the value of distributed solar and storage",
      meta: [
        {
          name: "description",
          content: `My results for ${this.response.projectTitle}`,
        },
        {
          property: "og:title",
          content:
            "Solva - Evaluate the value of distributed solar and storage",
        },
      ],
    };
  },
  computed: {
    chartStyles() {
      return {
        height: `${this.Barchartheight}px`,
        width: `${this.Barchartwidth}px`,
        position: "relative",
      };
    },
    harizondalChartStyles() {
      return {
        height: `${this.harizondalBarchartheight}px`,
        width: `${this.harizondalBarchartwidth}px`,
        position: "relative",
      };
    },
    LinechartStyles() {
      return {
        top: "10px",
        height: `${this.Linechartheight}px`,
        width: `${this.Linechartwidth}px`,
      };
    },
    pieChartStyles() {
      return {
        top: "10px",
        height: `${this.PieChartHeight}px`,
        width: `${this.PieChartWidth}px`,
      };
    },
  },
  data() {
    return {
      voltageviolationtooltip: "Instances of voltage violations (%) beyond permissible limits for BAU & DER in year 1",
      avgdistributiontooltip: "Average distribution loss (%) for BAU & DER in year 1",
      peakcapacitytooltip: "Single highest peak in year 1 as percentage of DT/Feeder/Substation capacity",
      loadprofiletooltip: "Grid_bau & Grid_der is displayed as meterred at the substation level and Load Profile is  displayed as metered at the points of consumption. ",
      voltageprofiletooltip: "Hourly voltage profile against permissible limits (106% to 90%) ",
      distributionlosstooltip: "Hourly distribution loss for year 1 (MWh)",
      derpowertooltip: "Hourly share of DER & Grid contribution ",
      dtpeakcapacitytooltip: "Single highest peak in year 1 as percentage of DT capacity",
      feederpeakcapacitytooltip:'Single highest peak in year 1 as percentage of Feeder capacity',
      substationpeakcapacitytooltip:'Single highest peak in year 1 as percentage of Substation capacity',
      dtcapacityupgradationtooltip: "Capacity upgradation is suggested if there are more than 5 instances in which the thermal capacity of  the DT is exceeded",
      feedercapacityupgradationtooltip: "Capacity upgradation is suggested if there are more than 5 instances in which the thermal capacity of  the Feeder is exceeded",
      substationcapacityupgradationtooltip: "Capacity upgradation is suggested if there are more than 5 instances in which the thermal capacity of  the Substation is exceeded",
      mindate:'',
      maxdate:'',
      loadProfileYearlyDataDateRange: {
        startDate:'',
        endDate: ''
      },
      yearlyVoltageProfileDateRange: {
        startDate:'',
        endDate: ''
      },

      distributionLossYearlyDataDateRange: {
        startDate: '',
        endDate: ''
      },
      voltageProfileYearlyDateRange: {
        startDate: '',
        endDate: ''
      },
      energyBalanceDerDataRange: {
        startDate: '',
        endDate: ''
      },
      loadProfileYearlyDataOption: {},
      voltageProfileYearlyDataOption: {},
      loadProfileYearlyDataMin: 0,
      loadProfileYearlyDataMax: 0,
      energyBalanceDerDataMax: 0,
      energyBalanceDerDataMin: 0,
      voltageProfileYearlyDataMax: 0,
      voltageProfileYearlyDataMin: 0,
      distributionLossYearlyDataMax: 0,
      distributionLossYearlyDataMin: 0,
      minMax: [],
      backgroundColors: ["#219fd4"],
      NetworkBenifitDataset: [],
      TotalVoderBenefitsDataset: [],
      SocietalBenefitsDataset: [],
      lineChartBackgroudColor: ["#219fd4", "#77b342", "#226443"],
      barChartDataLableProps: {
        anchor: "end",
        align: "top",
        color: ["#219fd4", "#77b342"],
        padding: 10,
        font: {
          size: 13,
        },
      },

      horizBarChartBackgroudColor: [
        "#6fc4e9",
        "#5cbde6",
        "#46b4e2",
        "#30abdf",
        "#219fd4",
      ],
      id: null,
      pieChartBackgroundColor: ["#219fd4", "#77b342", "#226443"],
      loadingLoadProfile: false,
      loadingVoltageProfile: false,
      loadingDistributionLoss: false,
      loadingEnergyBalanceDer: false,
      barChartColours: ["#219fd4", "#77b342"],
      toTitleCase: toTitleCase,
      downloadLoading: false,
      response: {},
      fromDate: "",
      toDate: "",
      menuFrom: "",
      loadProfileYearlyDataMenuFrom: "",
      voltageProfileYearlyDataMenuFrom: "",
      distributionLossYearlyDataDateMenuFrom: "",
      energyBalanceDerDataMenuFrom: "",
      GroupedLoadProfileYearlyData: {},
      menuTo: "",
      voltageProfileYearlyBeforeAfterDate: "",
      isDownload: false,
      selectedReportId: "",
      datasets: [],

      loading: false,
      reportMessage: "Loading...",
      isShow: false,
      iskeyfindingsDataLoaded: false,
      isSystemprofiledataLoaded: false,
      isPowerflowAnalysisReportLoaded: false,
      isVoltageProfileYearlyLoaded: false,
      isLoadProfileYearlyData: false,
      isEnergyBalanceDerDataLoad: false,
      isDistributionLossYearlyDataLoad: false,
      isEnergyBalanceDer: false,
      isDistributedenergyresourcesLoad: false,
      isSocietalBenefitsLoad: false,
      isNetworkBenifitLoad: false,
      isEnergyBalanceTotalLoad: false,
      publishedProjects: [],
      keyfindingsData: {},
      systemprofiledata: {},
      powerflowAnalysisData: {},
      voltageProfileYearlyData: [{ datasets: [], labels: [] }],
      loadProfileYearlyData: {},
      distributionLossYearlyData: {},
      energyBalanceDerData: {},
      energyBalanceTotal: {},
      energyBalanceTotal_X: [],
      overlay: true,
      Linechartheight: 250,
      Linechartwidth: 650,
      Barchartheight: 250,
      Barchartwidth: 250,
      harizondalBarchartheight: 250,
      harizondalBarchartwidth: 600,

      PieChartHeight: 200,
      PieChartwidth: 200,
      voltageviolation_x: [],
      voltageviolation_Y: [],
      avgDistributionLoss_x: [],
      avgDistributionLoss_y: [],
      feedercapacity_x: [],
      feedercapacity_y: [],
      capacityupgradation_x: [],
      capacityupgradation_y: [],
      LoadProfileBeforAfter_x: [],

      Voltage_BAU: [],
      Voltage_DER: [],

      LoadProfile_BAU: [],
      LoadProfile_DER: [],

      DistributionLoss_BAU: [],
      DistributionLoss_DER: [],

      NetworkBenifit_X: [],
      NetworkBenifit_Y: [],

      SocietalBenefts_X: [],
      SocietalBenefts_Y: [],

      Distributedenergyresources_X: [],
      Distributedenergyresources_Y: [],
      ACE: "",
      ADCC: "",
      ATCC: "",
      AGCC: "",
      Totalnetworkbenefit: "",
      totalVoderBenefits: "",
      ACEC: "",
      ASEC: "",
      ANE: "",
      APE: "",

      // _distributedenergyresources_Y: "",
      // _distributedenergyresources_X: "",

      Totalsocietalbenifit: "",
      TotalVODERbenefit: "",

      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
      chartColors: {
        borderColor: "#077187",
        pointBorderColor: "#0E1428",
        pointBackgroundColor: "#AFD6AC",
        backgroundColor: "#74A57F",
      },

      csv_distributedenergyresource: [],
      csv_distributedenergyresources: [],
      csv_distributedEnergyTotal: [],
      csv_SocietalBenefts: [],
      csv_DistributionLoss: [],
      csv_Voltage_BAU: [],
    };
  },

  mounted() {
    console.log('mounted!')
    this.getPublishedProjects();
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.selectedReportId = this.$route.params.id;
      this.getReport(this.selectedReportId);
      this.genSocialMediaData(this.selectedReportId);
    }
  },

  methods: {
    getHourSeries(date) {
      let hours = [];

      date.forEach((item, index) => {
        hours.push(index + 1);
      });
      return hours;
    },
    resetDate(object) {
      object.startDate = null;
      object.endDate = null;
    },
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
    setcsvData() {
      let networkBenefits = [
        [
          "Avoided cost of energy (ACE)",
          "Avoided distribution capacity cost (ADCC)",
          "Avoided transmission capacity cost (ATCC)",
          "Avoided generation capacity cost (AGCC)",
          "Total network benefits",
        ],
        [this.ACE, this.ADCC, this.ATCC, this.AGCC, this.Totalnetworkbenefit],
      ];
      this.csv_distributedenergyresource = networkBenefits;
      let societalBenefts = [
        [
          "Avoided CO2 Emissions costs",
          "Avoided SO2 Emissions costs",
          "Avoided NO2 Emissions",
          "Avoided PM2.5 Emissions",
          "Total societal benefits",
        ],
        [this.ACEC, this.ASEC, this.ANE, this.APE, this.Totalsocietalbenifit],
      ];
      this.csv_SocietalBenefts = societalBenefts;
      let distributedEnergyResources = [
        ["Network benefits", "Societal benefits", "Total VODER benefits"],
        [
          this.Totalnetworkbenefit,
          this.Totalsocietalbenifit,
          this.totalVoderBenefits,
        ],
      ];
      this.csv_distributedenergyresources = distributedEnergyResources;
      this.csv_distributedEnergyTotal = [
        ["grid", "Solar", "Storage"],
        this.energyBalanceTotal.datasets[0].data,
      ];
    },
    async downloadPdf() {
      const imageWidth = 160;
      const imageHeight = 60;
      const LeftMargine = 8;
      this.downloadLoading = true;
      const doc = new jsPDF();
      doc.setFontSize(13);
      const html2canvas = _html2canvas;
      const headStyles = { fillColor: ["#219fd4"] };
      const imageData =
        "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";
      const options = {
        type: "dataURL",
      };

      let keyfindingsdata = [
        [
          "Solar",
          this.keyfindingsData.solar == 0 ? "0.00 MW" : roundUp(this.keyfindingsData.solar,2) + " MW",
          "From Solar",
          this.keyfindingsData.fromSolarPercent == 0 ? "0.00 %" : roundUp(this.keyfindingsData.fromSolarPercent,2) + " %",
          "Voltage Violation",
          this.keyfindingsData.voltageViolationPercent == 0 ? "0.00 %" : roundUp(this.keyfindingsData.voltageViolationPercent,2) + " %",
          "Network Benefits",
          this.keyfindingsData.networkBenefits == 0 ? "0.00 INR/kWh" : roundUp(this.keyfindingsData.networkBenefits,2) + " INR/kWh",
        ],
        [
          "Storage",
          `${this.keyfindingsData.storageMWh == 0 ? "0.00" : roundUp(this.keyfindingsData.storageMWh,2)} MWh`,
          "From Storage",
          `${this.keyfindingsData.fromStoragePercent == 0 ? "0.00 " : roundUp(this.keyfindingsData.fromStoragePercent,2)} %`,
          "Distribution losses",
          `${this.keyfindingsData.distributionLossesPercent == 0 ? "0.00" : roundUp(this.keyfindingsData.distributionLossesPercent,2)} %`,
          "S&E Value",
          `${this.keyfindingsData.societalBenefits == 0 ? "0.00" : roundUp(this.keyfindingsData.societalBenefits,2)} INR/kWh`,
        ],
        [
          "Storage",
          `${this.keyfindingsData.storageMW == 0 ? "0.00" : roundUp(this.keyfindingsData.storageMW,2)} MW`,
          "From Grid",
          `${this.keyfindingsData.fromGridPercent == 0 ? "0.00" : roundUp(this.keyfindingsData.fromGridPercent,2)} %`,
          "Transmission Losses",
          `${this.keyfindingsData.transmissionLossesPercent == 0 ? "0.00" : roundUp(this.keyfindingsData.transmissionLossesPercent,2)} %`,
          "Total Value",
          `${this.keyfindingsData.totalBenefits == 0 ? "0.00" : roundUp(this.keyfindingsData.totalBenefits,2)} INR/kWh`, 
        ],
      ];


let systemProfile = [
       
        [
          "Name of Substation",
          this.systemprofiledata.substationName,
          "Interconnection Location  Solar",
          this.systemprofiledata.interconnectionLocationSolar,
        ],
        [
          this.response.analysisLevel==='dt'? 'Name of DT' :  this.response.analysisLevel==='feeder'? 'Name of Feeder' : '',
          this.response.analysisLevel==='dt'? this.systemprofiledata.feederName :  this.response.analysisLevel==='feeder'? this.systemprofiledata.feederName : '',
          "Storage Capacity(MW)",
          this.systemprofiledata.storageCapacityMW == 0 ? "0.00" : roundUp(this.systemprofiledata.storageCapacityMW,2),
        ],
        [
          "Feeder Type",
          this.systemprofiledata.feederType,
          "Storage Capacity(MWh)",
          this.systemprofiledata.storageCapacityMWh == 0 ? "0.00" : roundUp(this.systemprofiledata.storageCapacityMWh,2),
        ],
        [
           "Feeder Voltage(KV)",
           this.systemprofiledata.feederVoltage == 0 ? "0.00" : roundUp(this.systemprofiledata.feederVoltage,2),
          "Interconnection Location Storage",
          this.systemprofiledata.interconnectionLocationSolarStorage,
        ],
        [
          
          "Feeder Length(km)",
          this.systemprofiledata.feederLengthKm == 0 ? "0.00" : roundUp(this.systemprofiledata.feederLengthKm,2),
          this.response.analysisLevel==='dt'? 'DT Peak Load(MW)' :  this.response.analysisLevel==='feeder'? 'Feeder Peak Load(MW)' : 'Substation Peak Load(MW)',
          this.systemprofiledata.feederPeakLoadMW == 0 ? "0.00" : roundUp(this.systemprofiledata.feederPeakLoadMW,2),
        ],
         [
          "Solar Capacity(MW)",
          this.systemprofiledata.solarCapacityMWh == 0 ? "0.00" :roundUp(this.systemprofiledata.solarCapacityMWh,2),
          
        ],
       
      ];

      let networkBenefits = [
        [
          "Avoided cost of energy (ACE)",
          this.ACE == 0 ? "0.00 INR/kWh" : roundUp(this.ACE,2) + " INR/kWh",
        ],
        [
          "Avoided distribution capacity cost (ADCC)",
          this.ADCC == 0 ? "0.00 INR/kWh" : roundUp(this.ADCC,2) + " INR/kWh",
        ],
        [
          "Avoided transmission capacity cost (ATCC)",
          this.ATCC == 0 ? "0.00 INR/kWh" : roundUp(this.ATCC,2) + " INR/kWh",
        ],
        [
          "Avoided generation capacity cost (AGCC)",
          this.AGC == 0 ? "0.00 INR/kWh" : roundUp(this.AGCC,2) + " INR/kWh",
        ],
        [
          "Total network benefits",
          this.Totalnetworkbenefit == 0 ? "0.00 INR/kWh" : roundUp(this.Totalnetworkbenefit,2) + " INR/kWh",
        ],
      ];

      let societalBenefts = [
        [
          "Avoided CO2 Emissions costs",
          this.ACEC == 0 ? "0.00 INR/kWh" : roundUp(this.ACEC,2) + " INR/kWh",
        ],
        [
          "Avoided SO2 Emissions costs",
          this.ASEC == 0 ? "0.00 INR/kWh" : roundUp(this.ASEC,2) + " INR/kWh",
        ],
        [
          "Avoided NO2 Emissions",
          this.ANE == 0 ? "0.00 INR/kWh" : roundUp(this.ANE,2) + " INR/kWh",
        ],
        [
          "Avoided PM2.5 Emissions",
          this.APE == 0 ? "0.00 INR/kWh" : roundUp(this.APE,2) + " INR/kWh",
        ],
        [
          "Total societal benefits",
          this.Totalsocietalbenifit == 0
            ? "0.00 INR/kWh"
            : roundUp(this.Totalsocietalbenifit,2) + " INR/kWh",
        ],
      ];
      let distributedEnergyResources = [
        [
          "Network benefits",
          this.Totalnetworkbenefit == 0
            ? "0.00 INR/kWh"
            : roundUp(this.Totalnetworkbenefit,2) + " INR/kWh",
        ],
        [
          "Societal benefits",
          this.Totalsocietalbenifit == 0
            ? "0.00 INR/kWh"
            : roundUp(this.Totalsocietalbenifit,2) + " INR/kWh",
        ],
        [
          "Total VODER benefits",
          this.totalVoderBenefits == 0
            ? "0.00 INR/kWh"
            : roundUp(this.totalVoderBenefits,2) + " INR/kWh",
        ],
      ];

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      doc.addImage(imageData, "JPEG", 175, 10, 22, 9);

      doc.text(`Project : ${this.response.projectTitle}`, LeftMargine, 30);
      doc.text(
        `Analysis Level : ${toTitleCase(
          this.response.analysisLevel
        )}  |  Technology Type : ${toTitleCase(this.response.technologyType)}`,
        LeftMargine,
        40
      );

      let finalY = 45;
      doc.autoTable({
        columnStyles: {
          0: {
            cellWidth: 20,
          },
        },
        margin: { left: LeftMargine },
        headStyles: headStyles,
        startY: finalY,
        head: [["Key findings", "", "", "", "", "", "", ""]],
        body: keyfindingsdata,
      });

      finalY = finalY + 55;

      
      doc.autoTable({
        margin: { left: LeftMargine },
        headStyles: headStyles,
        startY: finalY,
        head: [["System Profile", "", "", ""]],
        body: systemProfile,
      });

      const can_voltageViolation = this.$refs.VoltageViolation;
      const can_avgdistricutionlosses = this.$refs.avgdistricutionlosses;
      const can_feedercapacity = this.$refs.feedercapacity;
      const can_capacityupgradation = this.$refs.capacityupgradation;

      const img_voltageViolation = await html2canvas(
        can_voltageViolation,
        options
      );

      const img_avgdistricutionlosses = await html2canvas(
        can_avgdistricutionlosses,
        options
      );
      const img_feedercapacity = await html2canvas(
        can_feedercapacity,
        options
      );

      const img_capacityupgradation = await html2canvas(
        can_capacityupgradation,
        options
      );

      const powerflowAnalysisDimenstion = this.getCanvasDimension(
        img_voltageViolation,
        doc
      );
      let topMargin = 170;
      let leftSpace = LeftMargine+10;
      doc.text("Powerflow Analysis", LeftMargine, topMargin);

      topMargin = topMargin + 10;
      doc.text("Voltage Violation % of hours - 1Year", LeftMargine+7, topMargin);
      topMargin = topMargin + 10;

      doc.addImage(
        img_voltageViolation,
        leftSpace,
        topMargin,
        80,
        60
      );

      topMargin = topMargin - 10;
      doc.text("Average distribution loss % - 1Year", 110, topMargin);
      topMargin = topMargin + 10;
      doc.addImage(
        img_avgdistricutionlosses,
        110,
        topMargin,
        80,
        60
      );
      topMargin = topMargin + 100;
      doc.text("1", 100, topMargin);
      doc.addPage();
      topMargin=30;

      doc.text(`Peak as % of ${toTitleCase(this.response.analysisLevel)} Capacity-1Year`, LeftMargine+7, topMargin);
      topMargin = topMargin + 10;
      doc.addImage(
        img_feedercapacity,
        leftSpace,
        topMargin,
        80,
        60
      );
      topMargin = topMargin - 10;
      doc.text("   Capacity upgradation in years", 110, topMargin);
      topMargin = topMargin + 10;
      doc.addImage(
        img_capacityupgradation,
        110,
        topMargin+2,
        80,
        60
      );

      const can_voltageProfileYearlyData = this.$refs.voltageProfileYearlyData;
      const can_loadProfileYearlyData = this.$refs.loadProfileYearlyData;
      const can_distributionLossYearlyData =
        this.$refs.distributionLossYearlyData;
      const can_energyBalanceDerData = this.$refs.energyBalanceDerData;

      const img_voltageProfileYearlyData = await html2canvas(
        can_voltageProfileYearlyData,
        options
      );
      const img_loadProfileYearlyData = await html2canvas(
        can_loadProfileYearlyData,
        options
      );
      const img_distributionLossYearlyData = await html2canvas(
        can_distributionLossYearlyData,
        options
      );
      const img_energyBalanceDerData = await html2canvas(
        can_energyBalanceDerData,
        options
      );

      const LoadProfileDimenstion = this.getCanvasDimension(
        can_loadProfileYearlyData,
        doc
      );

      topMargin = topMargin + 85;
      doc.text("   Load Profile and Grid power", LeftMargine, 120);
      doc.addImage(
        img_loadProfileYearlyData,
        LeftMargine-5,
        topMargin,
        (LoadProfileDimenstion.canvasWidth * 2)-7,
        LoadProfileDimenstion.canvasHeight * 2
      );

      topMargin = topMargin + 80;
      doc.text("   Voltage Profile", LeftMargine, 195);
      doc.addImage(
        img_voltageProfileYearlyData,
        LeftMargine-5,
        topMargin,
         (LoadProfileDimenstion.canvasWidth * 2)-7,
        LoadProfileDimenstion.canvasHeight * 2
      );

      doc.text("2",100,290)
      doc.addPage();
      topMargin = 30;
      doc.text("Distribution loss", LeftMargine, topMargin);
      topMargin = topMargin + 5;
      doc.addImage(
        img_distributionLossYearlyData,
        LeftMargine-5,
        topMargin,
         (LoadProfileDimenstion.canvasWidth * 2)-7,
        LoadProfileDimenstion.canvasHeight * 2
      );

      topMargin = 110;
      doc.text("DER Power Balance", LeftMargine, topMargin);
      topMargin = topMargin + 5;
      doc.addImage(
        img_energyBalanceDerData,
        LeftMargine-5,
        topMargin,
         (LoadProfileDimenstion.canvasWidth * 2)-7,
        LoadProfileDimenstion.canvasHeight * 2
      );

      

      const can_energyBalanceTotal = this.$refs.energyBalanceTotal;
      const img_energyBalanceTotal = await html2canvas(
        can_energyBalanceTotal,
        options
      );

      const EnergyBalanceDimenstion = this.getCanvasDimension(
        can_energyBalanceTotal,
        doc
      );
      topMargin = 190;
      doc.text("Energy Balance %", LeftMargine, topMargin);
      doc.addImage(
        img_energyBalanceTotal,
        EnergyBalanceDimenstion.marginX,
        topMargin,
        EnergyBalanceDimenstion.canvasWidth -20,
        EnergyBalanceDimenstion.canvasHeight -20
      );
      topMargin = topMargin + 100;
      doc.text("3", 100, topMargin);

      doc.addPage();
      topMargin = 25;
      doc.text(
        "Value of distributed energy resources analysis",
        LeftMargine,
        topMargin
      );
      topMargin = topMargin + 5;
      doc.autoTable({
        margin: { left: LeftMargine },
        headStyles: headStyles,
        topMargin,
        startY: EnergyBalanceDimenstion.canvasHeight - 80,
        head: [["Network benefits", ""]],
        body: networkBenefits,
      });

      const can_chartnetworkbenifit = this.$refs.chartnetworkbenifit;
      const img_chartnetworkbenifit = await html2canvas(
        can_chartnetworkbenifit,
        options
      );
      topMargin = topMargin + 5;
      doc.addImage(
        img_chartnetworkbenifit,
        LeftMargine,
        EnergyBalanceDimenstion.canvasHeight-30,
        imageWidth,
        imageHeight,
        topMargin
      );
      const can_SocietalBenefts = this.$refs.SocietalBenefts;
      const img_SocietalBenefts = await html2canvas(
        can_SocietalBenefts,
        options
      );

      doc.autoTable({
        margin: { left: LeftMargine },
        headStyles: headStyles,
        startY: 150,
        head: [["Societal benefits", ""]],
        body: societalBenefts,
      });
      doc.addImage(
        img_SocietalBenefts,
        LeftMargine,
        200,
        imageWidth,
        imageHeight
      );

      const can_distributedEnergyResources =
        this.$refs.distributedEnergyResources;
      const img_distributedEnergyResources = await html2canvas(
        can_distributedEnergyResources,
        options
      );

      topMargin = topMargin + 100;
      doc.text("4", 100, 290);
      doc.addPage();
      doc.autoTable({
        margin: { left: LeftMargine },
        headStyles: headStyles,
        startY: 30,
        head: [["Value of distributed energy resources", ""]],
        body: distributedEnergyResources,
      });

      doc.addImage(
        img_distributedEnergyResources,
        LeftMargine+2,
        70,
        imageWidth,
        imageHeight
      );
      doc.text("5", 100, 290);

      doc.save(this.response.projectTitle + ".pdf");
      this.downloadLoading = false;
    },
    initGraph() {
      this.getKeyFindings(this.response.keyFindings, this.keyfindingsData);
      this.getSystemProfile(
        this.response.systemProfile,
        this.systemprofiledata
      );
      this.getPowerflowAnalysis(
        this.response.powerFlowAnalysis,
        this.powerflowAnalysisData
      );
      this.getGroupedLoadProfileYearlyData();
      this.getLoadProfileYearlyData();
      this.voltageProfileYearly();
      this.getDistributionLossYearlyData();
      this.getEnergyBalanceDer();
      this.getEnergyBalanceTotal();
      this.getNetworkBenifit();
      this.societalBenefits();
      this.getTotalVoderBenefits();
      this.setcsvData();
      this.getLoadYear(this.response.loadProfileYear);
    },

    getCanvasDimension(canvase, document) {
      const pageWidth = document.internal.pageSize.getWidth();
      const pageHeight = document.internal.pageSize.getHeight();
      const width = canvase.style.width.slice(0, -2) * 1;
      const height = canvase.style.height.slice(0, -2) * 1;
      const widthRatio = pageWidth / width;
      const heightRatio = pageHeight / height;
      const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;
      const canvasWidth = (width * ratio) / 2;
      const canvasHeight = (height * ratio) / 2;
      const marginX = (pageWidth - canvasWidth) / 2;
      const marginY = (pageHeight - canvasHeight) / 2;
      return {
        pageWidth: pageWidth,
        pageHeight: pageHeight,
        canvasWidth: canvasWidth,
        canvasHeight: canvasHeight,
        marginX: marginX,
        marginY: marginY,
      };
    },
    getEnergyBalanceDer() {
      let startDate = formatDate(this.energyBalanceDerDataRange.startDate);
      let endDate = formatDate(this.energyBalanceDerDataRange.endDate);
      const Year = this.response.loadProfileYear;

      if (
        !this.energyBalanceDerDataRange.endDate &&
        !this.energyBalanceDerDataRange.startDate
      ) {
        startDate = formatDate(`01-02-${Year}`);
        endDate = formatDate(`01-02-${Year}`);
      }

      let filterDataset = [];
      let labels = [];
      let data = [];
      // this.minMax.splice(0, this.minMax.length);
      this.loadingEnergyBalanceDer = true;
      const object = this.response.powerFlowAnalysis.energyBalanceDer;
      const backgroundColor = this.lineChartBackgroudColor;

      let currentDate = new Date(`01-01-${Year}`);
      object.grid.forEach((item, i) => {
        if (i % 24 === 0 && i !== 0) {
          currentDate = new Date(
            currentDate.setDate(currentDate.getDate() + 1)
          );
        }
        labels[i] = formatDate(currentDate);
      });

      let dataset = [];
      let lbl = [];
      Object.keys(object).forEach((key, i) => {
        dataset.push({
          borderWidth: 1,
          borderColor: backgroundColor[i],
          backgroundColor: backgroundColor[i],
          label: toTitleCase(key),
          data: object[key],
        });
      });

      if (startDate && endDate.length > 0) {
        lbl = labels.filter(
          (item) =>
            formatFilterDate(item) >= formatFilterDate(startDate) &&
            formatFilterDate(item) <= formatFilterDate(endDate)
        );

        filterDataset = this.filterData(object, labels, startDate, endDate);
      } else {
        lbl = labels;
      }
      // data["labels"] = this.formatChartDateSeries(lbl);

      if (lbl.length <= 48) {
        data["labels"] = this.getHourSeries(lbl);
      } else {
        data["labels"] = this.formatChartDateSeries(lbl);
      }

      if (filterDataset.length > 0) {
        data["datasets"] = filterDataset.reverse();
      } else {
        data["datasets"] = dataset.reverse();
      }

      this.energyBalanceDerData = data;
      this.isEnergyBalanceDerDataLoad = true;
      this.loadingEnergyBalanceDer = false;
    },

    getDistributionLossYearlyData() {
      // let filterDataset = [];
      // let labels = [];
      // let data = [];
      // this.loadingDistributionLoss = true;
      // const startDate = formatDate(
      //   this.distributionLossYearlyDataDateRange.startDate
      // );
      // const endDate = formatDate(
      //   this.distributionLossYearlyDataDateRange.endDate
      // );

      // const object = this.response.powerFlowAnalysis.distributionLossYearlyData;
      // const backgroundColor = this.lineChartBackgroudColor;
      // const currentYear = new Date().getFullYear();
      // let currentDate = new Date(`01-01-${currentYear}`);
      // object.bau.forEach((item, i) => {
      //   if (i % 24 === 0 && i !== 0) {
      //     currentDate = new Date(
      //       currentDate.setDate(currentDate.getDate() + 1)
      //     );
      //   }
      //   labels[i] = formatDate(currentDate);
      // });

      // let dataset = [];
      // let lbl = [];
      // Object.keys(object).forEach((key, i) => {

      //   dataset.push({
      //     borderWidth: 1,
      //     borderColor: backgroundColor[i],
      //     backgroundColor: backgroundColor[i],
      //     label: toTitleCase(key),
      //     data: object[key],
      //   });
      // });

      // if (startDate && endDate.length > 0) {
      //   lbl = labels.filter(
      //     (item) =>
      //       formatFilterDate(item) >= formatFilterDate(startDate) &&
      //       formatFilterDate(item) <= formatFilterDate(endDate)
      //   );
      //   filterDataset = this.filterData(object, labels, startDate, endDate);
      // } else {
      //   lbl = labels;
      // }
      // data["labels"] = this.formatChartDateSeries(lbl);

      // if (filterDataset.length > 0) {

      //   data["datasets"] = filterDataset.reverse();
      // } else {

      //   data["datasets"] = dataset.reverse();
      // }
      // this.distributionLossYearlyData = data;
      // this.loadingDistributionLoss = false;

      let filterDataset = [];
      let labels = [];
      let data = [];
      const Year = this.response.loadProfileYear;
      let startDate = formatDate(
        this.distributionLossYearlyDataDateRange.startDate
      );
      let endDate = formatDate(
        this.distributionLossYearlyDataDateRange.endDate
      );

      if (
        !this.distributionLossYearlyDataDateRange.endDate &&
        !this.distributionLossYearlyDataDateRange.startDate
      ) {
        startDate = formatDate(`01-02-${Year}`);
        endDate = formatDate(`01-02-${Year}`);
      }

      const object = this.response.powerFlowAnalysis.distributionLossYearlyData;
      const backgroundColor = this.lineChartBackgroudColor;

      let currentDate = new Date(`01-01-${Year}`);

      object.bau.forEach((item, i) => {
        if (i % 24 === 0 && i !== 0) {
          currentDate = new Date(
            currentDate.setDate(currentDate.getDate() + 1)
          );
        }
        labels[i] = formatDate(currentDate);
      });

      let dataset = [];
      let lbl = [];
      Object.keys(object).forEach((key, i) => {
        dataset.push({
          borderWidth: 1,
          borderColor: backgroundColor[i],
          backgroundColor: backgroundColor[i],
          label: toTitleCase(key.replace("_", " ")),
          data: object[key],
        });
      });

      if (startDate && endDate.length > 0) {
        lbl = labels.filter(
          (item) =>
            formatFilterDate(item) >= formatFilterDate(startDate) &&
            formatFilterDate(item) <= formatFilterDate(endDate)
        );

        filterDataset = this.filterData(object, labels, startDate, endDate);
      } else {
        lbl = labels;
      }

      if (lbl.length <= 48) {
        data["labels"] = this.getHourSeries(lbl);
      } else {
        data["labels"] = this.formatChartDateSeries(lbl);
      }

      if (filterDataset.length > 0) {
        data["datasets"] = filterDataset.reverse();
      } else {
        data["datasets"] = dataset.reverse();
      }
      this.distributionLossYearlyData = data;
    },

    voltageProfileYearly() {
      const Year = this.response.loadProfileYear;
      this.minMax.splice(0, this.minMax.length);
      let startDate = formatDate(this.yearlyVoltageProfileDateRange.startDate);
      let endDate = formatDate(this.yearlyVoltageProfileDateRange.endDate);
      this.loadingVoltageProfile = true;

      if (
        !this.yearlyVoltageProfileDateRange.endDate &&
        !this.yearlyVoltageProfileDateRange.startDate
      ) {
        startDate = formatDate(`01-02-${Year}`);
        endDate = formatDate(`01-02-${Year}`);
      }

      const object = this.response.powerFlowAnalysis.voltageProfileYearlyData;
      const backgroundColor = this.lineChartBackgroudColor;
      let labels = [];
      let data = [];
      let filterDataset = [];

      let currentDate = new Date(`01-01-${Year}`);
      // let hour = 1;
      object.bau.forEach((item, i) => {
        if (i % 24 === 0 && i !== 0) {
          // hour = 1;
          currentDate = new Date(
            currentDate.setDate(currentDate.getDate() + 1)
          );
        }
        // labels[i] = `${formatDate(currentDate)} ${hour++}:00` ;
        labels[i] = formatDate(currentDate);
      });

      let dataset = [];
      let lbl = [];
      let voltMin = 0;
      let voltMax = 0;
      Object.keys(object).forEach((key, i) => {
        voltMin = object["voltMin"];
        voltMax = object["voltMax"];
        if (key !== "voltMin" && key !== "voltMax") {
          dataset.push({
            borderWidth: 1,
            borderColor: backgroundColor[i],
            backgroundColor: backgroundColor[i],
            label: toTitleCase(key.replace("_", " ")),
            data: object[key],
          });
        }
      });

      if (startDate && endDate.length > 0) {
        lbl = labels.filter(
          (item) =>
            formatFilterDate(item) >= formatFilterDate(startDate) &&
            formatFilterDate(item) <= formatFilterDate(endDate)
        );
        filterDataset = this.filterDataForVoltage(object, labels, startDate, endDate);
      } else {
        lbl = labels;
      }

      if (lbl.length <= 48) {
        data["labels"] = this.getHourSeries(lbl);
      } else {
        data["labels"] = this.formatChartDateSeries(lbl);
      }

      const AnnotationData = this.getAnnotationLineData(
        labels,
        voltMin,
        voltMax
      );

      if (filterDataset.length > 0) {
        filterDataset.push(AnnotationData.peak);
        filterDataset.push(AnnotationData.turf);

        data["datasets"] = filterDataset.reverse();
      } else {
        dataset.push(AnnotationData.peak);
        dataset.push(AnnotationData.turf);
        data["datasets"] = dataset.reverse();
      }

      this.voltageProfileYearlyData = data;
      this.loadingVoltageProfile = false;
    },

    getEnergyBalanceTotal() {
      const data = this.response.powerFlowAnalysis.energyBalanceTotal;
      const total =
        parseFloat(data.grid) +
        parseFloat(data.solar) +
        parseFloat(data.storage);
      const gridPerc = roundUp((data.grid / total) * 100, 2);
      const solarPerc = roundUp((data.solar / total) * 100, 2);
      const storagePerc = roundUp((data.storage / total) * 100, 2);

      this.energyBalanceTotal = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["Grid", "Solar", "Storage"],
        datasets: [
          {
            backgroundColor: this.pieChartBackgroundColor,
            data: [
              roundUp(gridPerc, 2),
              roundUp(solarPerc, 2),
              roundUp(storagePerc, 2),
            ],
            datalabels: {
              align: "center",
              anchor:"center",
              display: function(context) {
                var index=context.dataIndex;
                var value=context.dataset.data[index];
                return value > 0 || value < 0; // or >= 1 or ...
              },
              labels: {
                value: {
                  backgroundColor:"white",
                  borderRadius: 5,
                  color: "black",
                  padding: 3
                },
              },
              font: {
                weight: "bold",
                size: 12,
              },
            },
          },
        ],
      };
      this.isEnergyBalanceTotalLoad = true;
    },
    getLoadProfileYearlyData(isAnnotation = false) {
      // const loadProfileYearlyDataDateRange = {
      //   startDate: new Date(this.year,0,2),
      //   endDate: new Date(this.year,0,2)
      // }
      this.loadingLoadProfile = true;
      let filterDataset = [];
      let labels = [];
      let data = [];
      const Year = this.response.loadProfileYear;
      let startDate = formatDate(this.loadProfileYearlyDataDateRange.startDate);
      let endDate = formatDate(this.loadProfileYearlyDataDateRange.endDate);

      if (
        !this.loadProfileYearlyDataDateRange.endDate &&
        !this.loadProfileYearlyDataDateRange.startDate
      ) {
        startDate = formatDate(`01-02-${Year}`);
        endDate = formatDate(`01-02-${Year}`);
      }

      const object = this.response.powerFlowAnalysis.loadProfileYearlyData;
      const backgroundColor = this.lineChartBackgroudColor;

      let currentDate = new Date(`01-01-${Year}`);

      object.grid_bau.forEach((item, i) => {
        if (i % 24 === 0 && i !== 0) {
          currentDate = new Date(
            currentDate.setDate(currentDate.getDate() + 1)
          );
        }
        // let hour = i - 24
        labels[i] = formatDate(currentDate);
        // labels[i] = formatDate(currentDate) + ' ' + hour + ':00';
      });

      let dataset = [];
      let lbl = [];
      Object.keys(object).forEach((key, i) => {
        dataset.push({
          borderWidth: 1,
          borderColor: backgroundColor[i],
          backgroundColor: backgroundColor[i],
          label: toTitleCase(key.replace("_", " ")),
          data: object[key],
        });
      });

      if (startDate && endDate.length > 0) {
        lbl = labels.filter(
          (item) =>
            formatFilterDate(item) >= formatFilterDate(startDate) &&
            formatFilterDate(item) <= formatFilterDate(endDate)
        );

        filterDataset = this.filterData(object, labels, startDate, endDate);
      } else {
        lbl = labels;
      }

      if (lbl.length <= 48) {
        data["labels"] = this.getHourSeries(lbl);
      } else {
        data["labels"] = this.formatChartDateSeries(lbl);
      }

      if (filterDataset.length > 0) {
        data["datasets"] = filterDataset.reverse();
      } else {
        data["datasets"] = dataset.reverse();
      }
      this.loadProfileYearlyData = data;

      this.loadingLoadProfile = false;
    },
    getAnnotationLineData(data, maxPoint, minPoint) {
      const result = {
        peak: {
          elements: {
            point: {
              radius: 0,
            },
          },
          borderColor: "blue",
          borderWidth: 1.5,
          label: "Volt Min : " + roundUp(maxPoint, 2),

          data: Array.from(Array(data.length), () => maxPoint),
        },
        turf: {
          elements: {
            point: {
              radius: 0,
            },
          },
          borderColor: "red",
          borderWidth: 1.5,
          label: "Volt Max : " + roundUp(minPoint, 2),

          data: Array.from(Array(data.length), () => minPoint),
        },
      };
      return result;
    },
    getMinMax(data) {
      const min = Math.min(...data);
      const max = Math.max(...data);
      return { min, max };
    },
    filterData(object, labels, fromDate, toDate) {
      const backgroundColor = this.lineChartBackgroudColor;
      const range = this.indexRange(fromDate, toDate, labels);

      const filterDataset = [];

      Object.keys(object).forEach((key, i) => {
        const dt = object[key];

        const result = dt.filter(
          (item, idx) => idx >= range.fromIndex && idx <= range.toIndex
        );

        // const minmax = this.getMinMax(result);
        // this.minMax.push(minmax.min);
        // this.minMax.push(minmax.max);

        filterDataset.push({
          borderWidth: 1,
          borderColor: backgroundColor[i],
          backgroundColor: backgroundColor[i],
          label: toTitleCase(key),
          data: result,
        });
      });

      return filterDataset;
    },
    filterDataForVoltage(object, labels, fromDate, toDate) {
      const backgroundColor = this.lineChartBackgroudColor;
      const range = this.indexRange(fromDate, toDate, labels);
      const filterDatasetForVoltage = [];
      let counter  = 0;
      Object.keys(object).forEach((key, i) => {
          const dt = object[key];
        if (key !== "voltMin" && key !== "voltMax") {
          const result = dt.filter(
            (item, idx) => idx >= range.fromIndex && idx <= range.toIndex
          );
          const minmax = this.getMinMax(result);
          this.minMax.push(minmax.min);
          this.minMax.push(minmax.max);
          filterDatasetForVoltage.push({
            borderWidth: 1,
            borderColor: backgroundColor[i],
            backgroundColor: backgroundColor[i],
            label: toTitleCase(key),
            data: result,
          });
      }
      }
      );
      return filterDatasetForVoltage;
    },
    indexRange(fromDate, toData, data) {
      const fromIdx = this.findIndex(formatDate(fromDate), data);
      const toIdx = this.findIndex(formatDate(toData), data);

      const fromIndex = fromIdx[0];
      const toIndex = toIdx[toIdx.length - 1];

      return { fromIndex, toIndex };
    },
    findIndex(value, items) {
      var results = [];
      var idx = items.indexOf(value);
      while (idx != -1) {
        results.push(idx);
        idx = items.indexOf(value, idx + 1);
      }
      return results;
    },
    formatChartDateSeries(labels) {
      const labels_temp = [];
      const newDate = labels.forEach((item, i) => {
        labels_temp[i] = formatChartDate(item);
      });
      return labels_temp;
    },
    addDays(date, days) {
      let result = new Date(date);
      return result.setTime(date + days);
    },

    viewReport() {
      this.getReport(this.selectedReportId);
    },

   async genSocialMediaData(id){

      // const data  = {
      //   reportTitle : this.response.projectTitle? this.response.projectTitle : 'Solva Report',
      //   distributionLossesPercent: 2.701312256727477,
      //   fromGridPercent: 80.50676382012833,
      //   fromSolarPercent: 19.493236179871666,
      //   fromStoragePercent: 0,
      //   networkBenefdataits: 8.61485675760214,
      //   societalBenefits: 9.119075709567555,
      //   solar: 50,
      //   storageMW: 0,
      //   storageMWh: 0,
      //   totalBenefits: 17.733932467169694,
      //   transmissionLossesPercent: 4,
      //   voltageViolationPercent: 0,
      // }

      dataService
        .getById(`reports`, id)
        .then((res) => {
          if (res) {
            // console.log("response ",res)
            if(typeof(res) == 'string')
            {
              let result_without_NaN = res.replace(/\bNaN\b/g, 0.0); 
              let result_without_Infi = result_without_NaN.replace(/\bInfinity\b/g, 0.0);
              this.response = JSON.parse(result_without_Infi);
            }
            else
            {
              this.response = res;
            }



      const data  = {
        reportTitle : 'Solva - Report',
        distributionLossesPercent:  this.response.keyFindings.distributionLossesPercent,
        fromGridPercent: this.response.keyFindings.fromGridPercent,
        fromSolarPercent: this.response.keyFindings.fromSolarPercent,
        fromStoragePercent: this.response.keyFindings.fromStoragePercent,
        networkBenefdataits: this.response.keyFindings.networkBenefits,
        societalBenefits:   this.response.keyFindings.societalBenefits,
        solar:  this.response.keyFindings.solar ,
        storageMW:  this.response.keyFindings.storageMW ,
        storageMWh:   this.response.keyFindings.storageMWh,
        totalBenefits:  this.response.keyFindings.totalBenefits,
        transmissionLossesPercent:  this.response.keyFindings.transmissionLossesPercent ,
        voltageViolationPercent:  this.response.keyFindings.voltageViolationPercent,
      }


      dataService
      .generateSocialMediaData(id,data)
        .then((res) => {
          if (res) {
            console.log()
          }
        });
          } 
        })
        .catch(() => {
          console.log()
        });


    },
    async getReport(id) {
      this.loading = true;
      this.reportMessage = "Loading...";
      dataService
        .getById(`reports`, id)
        .then((res) => {
          if (res) {
            // console.log("response ",res)
            if(typeof(res) == 'string')
            {
              let result_without_NaN = res.replace(/\bNaN\b/g, 0.0); 
              let result_without_Infi = result_without_NaN.replace(/\bInfinity\b/g, 0.0);
              this.response = JSON.parse(result_without_Infi);
            }
            else
            {
              this.response = res;
            }
            
            this.initGraph();

            this.reportMessage = "";
            this.isDownload = true;

          } else {
            this.reportMessage = "Report not Found";
            this.isDownload = false;
            this.disableChartControls();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
        
    },
    getLoadYear(loadyear) {
      let loadProfileDateRange= {
        startDate : new Date(loadyear,0,2),
        endDate : new Date(loadyear,0,2),
      }
      this.loadProfileYearlyDataDateRange = loadProfileDateRange;
      this.yearlyVoltageProfileDateRange = loadProfileDateRange;
      this.distributionLossYearlyDataDateRange = loadProfileDateRange;
      this.voltageProfileYearlyDateRange = loadProfileDateRange;
      this.energyBalanceDerDataRange = loadProfileDateRange;
      this.mindate = new Date(loadyear,0,1);
      this.maxdate = new Date(loadyear,11,31)
    },

    disableChartControls() {
      this.iskeyfindingsDataLoaded = false;
      this.isSystemprofiledataLoaded = false;
      this.isPowerflowAnalysisReportLoaded = false;
      this.isEnergyBalanceTotalLoad = false;
      this.isNetworkBenifitLoad = false;
      this.isSocietalBenefitsLoad = false;
      this.isDistributedenergyresourcesLoad = false;
    },
    getKeyFindings(object, dataCollection) {
      Object.keys(object).forEach((key) => {
        dataCollection[key] = roundUp(object[key], 2);
      });
      this.iskeyfindingsDataLoaded = true;
    },
    getSystemProfile(object, dataCollection) {
      Object.keys(object).forEach((key) => {
        dataCollection[key] = object[key];
        if (
          (key === "interconnectionLocationSolarStorage" ||
            key === "interconnectionLocationSolar") &&
          dataCollection[key] === null
        ) {
          dataCollection[key] = "NA";
        }
      });
      this.isSystemprofiledataLoaded = true;
      // console.log(dataCollection)
    },
    getPowerflowAnalysis(object, dataCollection) {
      Object.keys(object).forEach((key) => {
        dataCollection[key] = object[key];
      });
      this.isPowerflowAnalysisReportLoaded = true;
    },

    getGroupedLoadProfileYearlyData() {
      const bgColors = {
        bau: ["#5ebee6", "#3cb0e1", "#219fd4", "#3cb0e1", "#5ebee6"],
        der: ["#9fcd77", "#8bc25a", "#77b342", "#8bc25a", "#9fcd77"],
      };
      let data = [];
      let dataCollection = {};
      const object = this.response.powerFlowAnalysis.upgradationCapacityYears;
      //console.log("data object", object);
      const d = {};
      Object.keys(object).forEach((key) => {
        //console.log('object[key] ',object[key])
        dataCollection[key] = object[key];
      });

      let x = [];
      let bau = [];
      let der = [];
      //console.log('dataCollection bau',dataCollection['bau']);
      //console.log('dataCollection der',dataCollection['der']);
      bau.push({
          data: [dataCollection['bau'][0],dataCollection['bau'][1]],
          backgroundColor: [bgColors.bau[0], bgColors.der[1]],
              datalabels: this.barChartDataLableProps,
            });

      der.push({
              data: [dataCollection['der'][0],dataCollection['der'][1]],
              backgroundColor: [bgColors.bau[0], bgColors.der[1]],
                datalabels: this.barChartDataLableProps,
              });
      x.push(bau[0]);
      x.push(der[0]);
      this.GroupedLoadProfileYearlyData["datasets"] = x;
    },

    getNetworkBenifit() {
      const object =
        this.response.distributedEnergyResourcesAnalysis.networkBenefits;
      this.ACE = roundUp(object.avoidedCostEnergy, 2);
      this.ADCC = roundUp(object.avoidedDistributionCapacityCost, 2);
      this.ATCC = roundUp(object.avoidedTransmissionCapacityCost, 2);
      this.AGCC = roundUp(object.avoidedGenerationCapacityCost, 2);
      this.Totalnetworkbenefit = roundUp(object.totalNetworkBenefits, 2);
      this.NetworkBenifit_X = [
        // "Avoided cost energy",
        // "Avoided districution capacity cost",
        // "Avoided transmission capacity cost",
        // "Avoided generation capacity cost",
        // "Total network benefits",
        "ACE",
        "ADCC",
        "ATCC",
        "AGCC",
        "Total network benefits",
      ];
      this.NetworkBenifit_Y = [
        this.ACE,
        this.ADCC,
        this.ATCC,
        this.AGCC,
        this.Totalnetworkbenefit,
      ];
      this.NetworkBenifitDataset = this.getCumulativeBarValue(
        this.NetworkBenifit_Y
      );
      this.isNetworkBenifitLoad = true;
    },

    getCumulativeBarValue(baseData) {
      const data = [];
      let total = 0;
      for (let i = 0; i < baseData.length; i++) {
        const vStart = total;
        total += parseFloat(baseData[i]);
        if (i === baseData.length - 1) {
          data.push([0, baseData[i]]);
        } else {
          data.push([vStart, total]);
        }
      }
      // this.backgroundColors = data.map(
      //   (o, i) => "rgba(255, 99, 132, " + (i + (11 - data.length)) * 0.1 + ")"
      // );
      return data;
    },
    societalBenefits() {
      const object =
        this.response.distributedEnergyResourcesAnalysis.societalBenefits;
      this.ACEC = roundUp(object.avoidedCO2EmissionsCost, 2);
      this.ASEC = roundUp(object.avoidedSO2EmissionsCost, 2);
      this.ANE = roundUp(object.avoidedNO2EmissionsCost, 2);
      this.APE = roundUp(object.avoidedPM2_5EmissionsCost, 2);
      this.Totalsocietalbenifit = roundUp(object.totalSocietalBenefits, 2);
      this.SocietalBenefts_X = [
        "Avoided CO2 Emissions",
        "Avoided SO2 Emissions",
        "Avoided NO2 Emissions",
        "Avoided PM 2.5 Emissions",
        "Total Societal Benefits",
      ];
      this.SocietalBenefts_Y = [
        this.ACEC,
        this.ASEC,
        this.ANE,
        this.APE,
        this.Totalsocietalbenifit,
      ];
      this.SocietalBenefitsDataset = this.getCumulativeBarValue(
        this.SocietalBenefts_Y
      );
      this.isSocietalBenefitsLoad = true;
    },
    getTotalVoderBenefits() {
      const object = this.response.distributedEnergyResourcesAnalysis;
      this.totalVoderBenefits = roundUp(object.totalVoderBenefits, 2);
      this.Distributedenergyresources_Y = [
        this.Totalnetworkbenefit,
        this.Totalsocietalbenifit,
        this.totalVoderBenefits,
      ];
      this.Distributedenergyresources_X = [
        "Network benefits",
        "Societal benefits",
        "Total VODER benefits",
      ];
      this.TotalVoderBenefitsDataset = this.getCumulativeBarValue(
        this.Distributedenergyresources_Y
      );
      this.isDistributedenergyresourcesLoad = true;
    },
    getPublishedProjects() {
      dataService.list("projects/published").then((res) => {
        this.publishedProjects = res;
      });
    },
    downloadLoadandGridCsv(title, source) {
      let row = [];
        source[0].data.forEach((item, i) => {
          row[i] = [item, source[1].data[i], source[2].data[i]];
        });
      let datasource = [];
        datasource = [["Load", "Grid_DER", "Grid_BAU"]];
      const dataset = datasource.concat(row);
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [...dataset.map((item) => Object.values(item).join(","))]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", title + ".csv");
      link.click();
    },
    downloadDERPowerBalanceCsv(title, source, headers) {
      let row = [];
      let datasource = [];
        console.log("Source data",source)
        if(source[0].data.length == 0){
        source[1].data.forEach((item, i) => {
          row[i] = [item, source[2].data[i]];
        });
        datasource = [["Solar", "Grid"]];
      }
      else{
        source[0].data.forEach((item, i) => {
          row[i] = [item, source[1].data[i],source[2].data[i]];
        });
        datasource = [["Storage", "Solar", "Grid"]];
      }
      const dataset = datasource.concat(row);
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [...dataset.map((item) => Object.values(item).join(","))]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", title + ".csv");
      link.click();
    },
    downloadLargeCsv(title, source, headers) {
      let row = [];
      if (!headers) {
        source[0].data.forEach((item, i) => {
          row[i] = [item, source[1].data[i]];
        });
      } else {
        console.log("Source data",source)
        source[1].data.forEach((item, i) => {
          row[i] = [item, source[1].data[i], source[2].data[i]];
        });
      }

      let datasource = [];
      if (!headers) {
        datasource = [["DER", "BAU"]];
      } else {
        datasource = [["Storage", "Solor", "Grid"]];
      }
      const dataset = datasource.concat(row);
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [...dataset.map((item) => Object.values(item).join(","))]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", title + ".csv");
      link.click();
    },
    downloadVoltageCsv(title, source) {
      let row = [];
        source[2].data.forEach((item, i) => {
          row[i] = [item, source[3].data[i]];
        });
      let datasource = [];
      datasource = [["DER", "BAU"]];
      const dataset = datasource.concat(row);
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [...dataset.map((item) => Object.values(item).join(","))]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", title + ".csv");
      link.click();
    },
    downloadcsv(title, source) {
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [...source.map((item) => Object.values(item).join(","))]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", title + ".csv");
      link.click();
    },
    // getAnnotationOption(peak, turf, yTitle, annotationId) {
    //     return {
    //         // plugins: {
    //         autocolors: true,
    //         annotation: {
    //             annotations: [
    //                 {
    //                     peak: {
    //                         id: "peak_" + annotationId,
    //                         type: "line",
    //                         yMin: peak,
    //                         yMax: peak,
    //                         backgroundColor: "green",
    //                     },
    //                     turf: {
    //                         id: "turf_" + annotationId,
    //                         type: "line",
    //                         yMin: turf,
    //                         yMax: turf,
    //                         backgroundColor: "pink",
    //                     },
    //                 },
    //             ],
    //         },
    //         // },
    //         scales: {
    //             y: {
    //                 title: {
    //                     display: true,
    //                     text: yTitle,
    //                 },
    //             },
    //         },
    //         responsive: true,
    //         maintainAspectRatio: false,
    //         layout: {
    //             padding: {
    //                 left: 20,
    //                 right: 20,
    //                 top: 30,
    //                 bottom: 10,
    //             },
    //         },
    //     };
    // },
  },
};
</script>
<style>
.v-select__selections input {
  display: none;
}
.select-filter-col {
  min-width: 200px;
}
.active-col {
  max-width: 150px;
}
.default-border {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.slot {
  background-color: #219fd4;
  padding: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-black {
  color: #000;
}
</style>
